import { onBeforeUnmount, ref, watch } from "vue";
import { api } from "../api/client";
import { inbox } from "./inbox";
import { session } from "./session";

/** "(3) DoneTalk" while 3 conversations wait for the person, as WhatsApp Web; "DoneTalk" at none. */
export function tabTitle(waiting: number): string {
  return waiting > 0 ? `(${waiting}) DoneTalk` : "DoneTalk";
}

/** How often the count is read on screens without the inbox's live connection. */
const POLL_MS = 30_000;

/**
 * Keeps the browser tab's title on what waits for the person (the queue and their conversations
 * with unread messages), on every screen of the workspace. The inbox and the agenda keep a live
 * connection and their counts; elsewhere the count is read every 30 seconds.
 */
export function useTabTitle(): void {
  const polled = ref(0);
  let timer: ReturnType<typeof setInterval> | null = null;
  async function poll() {
    const slug = session.slug;
    if (!slug || inbox.slug === slug) return;
    try {
      const r = await api<{ counts: { attention?: number } }>(
        `/v1/c/${slug}/conversations/counts`,
      );
      if (session.slug === slug) polled.value = r.counts.attention ?? 0;
    } catch {
      // A screen without access to conversations keeps the plain title.
    }
  }
  watch(
    () => session.slug,
    (slug) => {
      if (timer) clearInterval(timer);
      timer = null;
      polled.value = 0;
      if (!slug) return;
      void poll();
      timer = setInterval(() => void poll(), POLL_MS);
    },
    { immediate: true },
  );
  watch(
    () =>
      session.slug && inbox.slug === session.slug
        ? (inbox.counts.attention ?? 0)
        : session.slug
          ? polled.value
          : 0,
    (n) => (document.title = tabTitle(n)),
    { immediate: true },
  );
  onBeforeUnmount(() => {
    if (timer) clearInterval(timer);
  });
}
